import { Alert, Stack, useTheme } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useUserContext } from '../../../contexts/UserContext';
import { useDigitalDossierSectionContext } from '../context/DigitalDossierSectionContext';
import { DigitalDossierAside } from '../shared/DigitalDossierAside';
import { DigitalDossierInformativeAlert } from './components/DigitalDossierInformativeAlert';

export const DigitalDossierSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { userHasPendingChanges, setUserHasPendingChanges } = useUserContext();

  const { tabsData, digitalDossierStatus } = useDigitalDossierSectionContext();

  const { dossierStatus } = digitalDossierStatus ?? {};
  const { rucaNotCurrentWarning } = dossierStatus ?? {};

  return (
    <DigitalDossierAside
      tabsData={tabsData}
      theme={theme}
      alertsSpot={
        <Stack gap={4}>
          <DigitalDossierInformativeAlert />
          <Alert
            title={t('explorer.digitalDossier.generalInformation.alert.title')}
            variant="gray"
          />
          {rucaNotCurrentWarning ? (
            <Alert
              title={t(
                `explorer.digitalDossier.rucaNotCurrentWarning.${rucaNotCurrentWarning}.title`,
              )}
              description={t(
                `explorer.digitalDossier.rucaNotCurrentWarning.${rucaNotCurrentWarning}.text`,
              )}
              variant="error"
              showCloseButton={false}
            />
          ) : null}
        </Stack>
      }
      hasUserPendingChanges={userHasPendingChanges}
      setUserHasPendingChanges={setUserHasPendingChanges}
    />
  );
};
